<app-deprecated-modal #documentPreview>
    <app-pdf-viewer #pdfViewer></app-pdf-viewer>
</app-deprecated-modal>

<div class="page-container">
    <app-header title="Paystubs"></app-header>

    <ui-card class="scrollable-table-container" [class.loading]="isLoading" [withSpacing]="false" [withMargin]="false">
        <!-- Has Content -->
        <ng-container *ngIf="!isLoading && paginator.total">
            <app-segment-header
                [paginator]="paginator"
                title="{{ 'payroll.paystubs.title.self' | translate }}"
            ></app-segment-header>
            <div class="responsive-table" role="table">
                <div role="row">
                    <h4 role="columnheader">{{ 'payroll.paystubs.dateSent' | translate }}</h4>
                </div>
                <div class="table-body" role="rowgroup">
                    <div *ngFor="let paystub of paginator.values" role="row">
                        <div role="cell">{{ paystub?.chequeDate | appDate }}</div>
                        <div class="only-large" role="cell">
                            <ui-button
                                type="link"
                                (click)="pdfViewer.setSource(getUrl(paystub)); documentPreview.show()"
                            >
                                {{ 'payroll.paystubs.view' | translate }}
                            </ui-button>
                        </div>
                        <div role="cell">
                            <ui-button type="link" (click)="onDownload(paystub)">
                                <span class="only-large">{{ 'payroll.paystubs.download' | translate }}</span>
                                <span class="hide-large">{{ 'payroll.paystubs.view' | translate }}</span></ui-button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Empty State -->
        <ng-container *ngIf="!isLoading && !paginator.total">
            <app-empty-state
                src="/assets/illustrations/documents.png"
                label="{{ 'payroll.paystubs.notFound' | translate }}"
            ></app-empty-state>
        </ng-container>
    </ui-card>
</div>
